// extracted by mini-css-extract-plugin
module.exports = {"padding-col":"CredentialsFormStep_padding-col__rol3p","label-text":"CredentialsFormStep_label-text__I3UL1"};